import PropTypes from 'prop-types'
import { AdasBox, AdasTypography } from '@components/wrapper-components'
import { WORK_ORDER_TYPE } from 'constants'

export const IdDisplay = ({ itemId, roNumber, itemType, serviceOnly, insuranceName }) => {
  return (
    <AdasBox className='flex-col md:flex-row items-start md:items-center flex'>
      <AdasBox className='items-start md:items-center flex'>
        <AdasBox className='mr-[.2rem] flex'>
          <AdasTypography variant='body2' color={'secondary'}>
            <span>{itemType} #</span>
            {itemId}
          </AdasTypography>
        </AdasBox>
        <AdasBox className='flex'>
          <AdasTypography variant='body2' color={'secondary'} className='mr-[.2rem]'>
            |
          </AdasTypography>
          <AdasTypography variant='body2' color={'secondary'}>
            RO #{roNumber}
          </AdasTypography>
        </AdasBox>
      </AdasBox>
      {serviceOnly !== undefined && (
        <AdasBox className='ml-0 md:ml-[.2rem] flex'>
          <AdasTypography variant='body2' color={'secondary'} className='hidden md:inline mr-0 md:mr-[.2rem]'>
            |
          </AdasTypography>
          <AdasTypography variant='body2' color={'secondary'}>
            {WORK_ORDER_TYPE[serviceOnly] || ''}
          </AdasTypography>
        </AdasBox>
      )}
      {insuranceName && (
        <AdasBox className='ml-0 md:ml-[.2rem] flex'>
          <AdasTypography variant='body2' color={'secondary'} className='hidden md:inline mr-0 md:mr-[.2rem]'>
            |
          </AdasTypography>
          <AdasTypography variant='body2' color={'secondary'}>
            {insuranceName}
          </AdasTypography>
        </AdasBox>
      )}
    </AdasBox>
  )
}

IdDisplay.propTypes = {
  itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  roNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  itemType: PropTypes.string.isRequired,
  sx: PropTypes.object
}
